import React, { useState } from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const colors = [
  { name: 'Svart', code: '#000000' },
  { name: 'Vit', code: '#FFFFFF' },
  { name: 'Grå', code: '#808080' },
  { name: 'Röd', code: '#FF0000' },
  { name: 'Blå', code: '#0000FF' },
  { name: 'Gul', code: '#FFFF00' },
  { name: 'Grön', code: '#008000' },
  { name: 'Orange', code: '#FFA500' },
  { name: 'Lila', code: '#800080' },
  { name: 'Brun', code: '#A52A2A' },
  { name: 'Rosa', code: '#FFC0CB' },
  { name: 'Turkos', code: '#40E0D0' },
  { name: 'Guld', code: '#FFD700' },
  { name: 'Silver', code: '#C0C0C0' },
];

const ColorFilter = (props) => {
  const isMobileView = useMediaQuery('(max-width:600px)');
  const [selectedColor, setSelectedColor] = useState('');

  const handleColorClick = (colorName) => {
    const next = colorName === selectedColor ? '' : colorName;
    setSelectedColor(next);
    props.setSelectedColor(next);
  };

  return (
    <div>
      <div style={{
        display: 'grid',
        gridTemplateColumns: isMobileView ? 'repeat(4, 1fr)' : 'repeat(5, 1fr)',
        gap: '8px',
      }}>
        {colors.map((color) => {
          const active = props.selectedColor === color.name.toLowerCase();
          const isWhite = color.code === '#FFFFFF';
          return (
            <button
              key={color.name}
              onClick={() => handleColorClick(color.name.toLowerCase())}
              style={{
                display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '6px',
                padding: '10px 4px', borderRadius: '12px', cursor: 'pointer',
                border: active ? '2px solid #161825' : '2px solid transparent',
                backgroundColor: active ? '#f8f7ff' : '#fafafa',
                transition: 'all 0.15s ease',
              }}
              onMouseOver={(e) => { if (!active) e.currentTarget.style.backgroundColor = '#f0f0f0'; }}
              onMouseOut={(e) => { if (!active) e.currentTarget.style.backgroundColor = active ? '#f8f7ff' : '#fafafa'; }}
            >
              <div style={{
                width: 28, height: 28, borderRadius: '50%',
                backgroundColor: color.code,
                border: isWhite ? '2px solid #ddd' : active ? '2px solid #161825' : '2px solid transparent',
                boxShadow: active ? '0 0 0 2px rgba(22,24,37,0.15)' : 'none',
                transition: 'all 0.15s ease',
              }} />
              <span style={{
                fontSize: '11px', fontWeight: active ? 600 : 400,
                color: active ? '#161825' : '#666',
              }}>
                {color.name}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ColorFilter;
